jQuery(document).ready(function( $ ){
	// START JQUERY
	logit = (typeof logit !== 'undefined')? logit : false;

	// start by adding id of element to popon
	modal_onload_enable = (typeof modal_onload_enable !== 'undefined')? modal_onload_enable : false;
	modal_onload_target = (typeof modal_onload_target !== 'undefined')? modal_onload_target : false;
	modal_onload_autohash = (typeof modal_onload_autohash !== 'undefined')? modal_onload_autohash : true;

	modal_fill_enable = (typeof modal_fill_enable !== 'undefined')? modal_fill_enable : false;
	modal_fill_id = (typeof modal_fill_id !== 'undefined')? modal_fill_id : false;
	modal_fill_target = (typeof modal_fill_target !== 'undefined')? modal_fill_target : false;
	modal_fill_title = (typeof modal_fill_title !== 'undefined')? modal_fill_title : '';

	// modal_onload
	if(modal_onload_enable && (modal_onload_target || modal_onload_autohash)) {

		if(modal_onload_autohash) {
				var modal_onload_hash = window.location.hash;
				if(logit) console.log('[MODAL ONLOAD] Enabled HASH ' + modal_onload_hash);
				modal_onload_target = modal_onload_hash;
		} else {
				if(logit) console.log('[MODAL ONLOAD] Enabled ID ' + modal_onload_target);
		}

		if($(modal_onload_target).hasClass('modal') && $(modal_onload_target).length) {
			if(logit) console.log('[MODAL ONLOAD] Opened ' + modal_onload_target);
			$(modal_onload_target).modal('show');
		} else  {
			if(logit) console.log('[MODAL ONLOAD] Error. Modal not found:' + modal_onload_target);
		}
	} else {
		if(logit == 2) console.log('[MODAL ONLOAD] Disabled');
		if(logit == 2) console.log('[MODAL ONLOAD] start by adding javascript variable modal_onload_enable & modal_onload_target (id of html element). Other variables: modal_onload_autohash');
	}


if(modal_fill_enable && modal_fill_id) {
	if(logit) console.log('[MODAL FILL] Enabled ' + modal_fill_id);
	const fillModal = document.getElementById(modal_fill_id);
	if (fillModal) {
	  fillModal.addEventListener('show.bs.modal', event => {

	    // Button that triggered the modal
	    const button = event.relatedTarget;
	    // Extract info from data-bs-* attributes
	    const modal_product = button.getAttribute('data-bs-modal-product');
			const modal_product_target = button.getAttribute('data-bs-modal-product-target');
			const modal_action =  button.getAttribute('data-bs-modal-action');
			const modal_action_target =  button.getAttribute('data-bs-modal-action-target');
			const modal_title =  button.getAttribute('data-bs-modal-title');
			const modal_action_title =  button.getAttribute('data-bs-modal-action-title');
			const modal_collapse_show =  button.getAttribute('data-bs-modal-collapse-show');
			const modal_collapse_hide =  button.getAttribute('data-bs-modal-collapse-hide');
			const modal_target_show =  button.getAttribute('data-bs-modal-target-show');
			const modal_target_hide =  button.getAttribute('data-bs-modal-target-hide');
	    // If necessary, you could initiate an Ajax request here
	    // and then do the updating in a callback.

			var modal_fill_title_current  = '';

	    // Update the modal's content.
	    const modalTitle = fillModal.querySelector('.modal-title');
			if(modal_action_title) modal_fill_title_current = modal_action_title + ' ' + modal_fill_title;

			if(modal_title) modal_fill_title_current = modal_fill_title_current + ' ' + modal_title;

			if(modal_fill_title_current) {
				 modalTitle.textContent = modal_fill_title_current;
				 if(logit == 2) console.log('[MODAL FILL] Filling modal title: ' + modal_fill_title_current);
			}


			if(modal_collapse_show) {
				const modalBodyQuery = '#' + modal_fill_id + ' .modal-body ' + modal_collapse_show;
				$(modalBodyQuery).collapse('show');
			}


			if(modal_fill_target && modal_action && modal_fill_title_current) {
				const modalBodyInput = fillModal.querySelector('.modal-body ' + modal_fill_target);
				modalBodyInput.value = new_modal_value = modal_action + ': ' + modal_fill_title_current;
			} else {

			}

			if(modal_action_target && modal_action) {
				const modalBodyInput = fillModal.querySelector('.modal-body ' + modal_action_target);
				modalBodyInput.value = modal_action;
			} else {

			}

			if(modal_product_target && modal_product) {
				const modalBodyInput = fillModal.querySelector('.modal-body ' + modal_product_target);
				const modalBodyQuery = '#' + modal_fill_id + ' .modal-body ' + modal_product_target;
				var new_modal_type = $(modalBodyQuery).attr('type');
				//if(logit == 2) console.log('[MODAL FILL] Filling product as input type: ' + new_modal_type);

				if(new_modal_type == 'checkbox') {
					$(modalBodyQuery).prop('checked', true);
				} else {
					modalBodyInput.value = modal_product;
				}

			} else {

			}


			if(logit==2) console.log('[MODAL FILL] Opened ' + modal_fill_id + ' with title ' + modal_fill_title_current + ' & value ' + new_modal_value);



	  })
	}
} else {
	if(logit == 2) console.log('[MODAL FILL] Disabled');
	if(logit == 2) console.log('[MODAL FILL] start by adding javascript variable modal_fill_enable, modal_fill_id (id of html element) & modal_fill_target (id of html input) . Other variables: modal_fill_title,');
}





	// END JQUERY
});
